import Axios from 'axios'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Topbar from '../../Common/Topbar'
import Spinner from '../../Components/Spinner'
import config from '../../Shared/config'
import { TeacherCard } from '../Home/Teachers'
import './OnlineClassList.scss'

export default class OnlineClassList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            teachersArray: [],
            teachersFetching: true,
            teachersFetched: false,
            moreFetching: false,
        }
    }

    componentDidMount() {
        const id = this.props?.match?.params?.class_id
        this.getTeachersByClass(id).then(res => {

            this.setState({
                teachersArray: res,
                teachersFetching: false,
                teachersFetched: true,
                moreFetching: false,
            })

        }).catch(err => {
            console.error(err)
            this.setState({
                teachersArray: [],
                teachersFetching: false,
                teachersFetched: true,
                moreFetching: false
            })
        })
    }

    getTeachersByClass = async (id) => {
        const url = `${config.apiUrl}/Teacher/getAllByClass?id=${id}`;
        return Axios.get(url).then(res => {
            if (!res?.data?.error) {
                return res.data.data
            }
        })
    }

    render() {

        const { teachersArray, teachersFetching, teachersFetched, moreFetching, nextPageNumber } = this.state

        return (
            <div className='allteachers'>
                <Topbar type={'fixedover'} theme={'solid'} />
                <div className="allteachers__content">
                    <div className='teachers'>

                        <h1>Teachers  <img alt='features' src={'https://www.flaticon.com/svg/static/icons/svg/2436/2436654.svg'}></img></h1>
                        {
                            teachersFetching ? (
                                <>
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                    <Spinner />
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                </>

                            ) : (
                                    teachersFetched ? (
                                        <>
                                            <div className="cards">
                                                {
                                                    teachersArray.map((item, idx) => {
                                                        return <Link to={`/online-listings/${item._id}`}><TeacherCard teacher={item} /></Link>
                                                    })
                                                }
                                            </div>

                                            {
                                                moreFetching ? (
                                                    <>
                                                        <div style={{ padding: '20px 0px' }} className="space"></div>
                                                        <Spinner />
                                                        <div style={{ padding: '20px 0px' }} className="space"></div>
                                                    </>
                                                ) : null
                                            }

                                        </>
                                    ) : null
                                )
                        }
                        {
                            !nextPageNumber ? (
                                <div className="result-end">
                                    Oh no! We ran out of suggestions. <span role='img' aria-label='astonished'>😟</span>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}
